/* eslint-disable import/no-anonymous-default-export */
import { SET_PROMPTER_ON } from '../actionConstants';

export default (state = '', action) => {
  switch (action.type) {
    case SET_PROMPTER_ON:
      return action.payload;
    default:
      return state;
  }
};
